import { toastr } from 'react-redux-toastr';

const showError = (title: string, message: string) => {
    toastr.error(title, message, { removeOnHover: false });
};

export default showError;
